module.exports = __webpack_public_path__ + "static/media/minecraft-example.7f4afb78.gif";